import { AzureDataExplorerCopySource } from 'app/model/pipeline/copysource/azure-data-explorer.copysource';
import { KustoDatabaseDataset, Metamodel } from 'shell-models-lib';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: adfModelTypeMap.kustoDatabase.copySourceType,
    display: [
        format(stringResources.ModelName_CopySourceTemplate, stringResources.Kusto_DisplayText),
        format(stringResources.ModelName_CopySourcesTemplate, stringResources.Kusto_DisplayText)
    ],
    tags: { datasetModel: Metamodel.modelFor(KustoDatabaseDataset) }
})
export class KustoDatabaseCopySource extends AzureDataExplorerCopySource {}
